import { render, staticRenderFns } from "./AlfaWidget.vue?vue&type=template&id=e13554fe&scoped=true"
import script from "./AlfaWidget.vue?vue&type=script&lang=js"
export * from "./AlfaWidget.vue?vue&type=script&lang=js"
import style0 from "./AlfaWidget.vue?vue&type=style&index=0&id=e13554fe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e13554fe",
  null
  
)

export default component.exports